const PMS = () => {
  return <div>PMS</div>;
};

export default PMS;
